import React from "react";
import { imageUrl } from "@/lib/api";

// Deterministic placeholder color based on the product id / title.
const PLACEHOLDERS = ["#DCE7E2", "#E4DED2"];

export const ProductImage = ({ images, seed = "", alt = "", className = "" }) => {
  const src = images && images.length ? imageUrl(images[0]) : null;
  const color = PLACEHOLDERS[(seed.length || 0) % 2];

  if (!src) {
    return (
      <div
        className={`flex items-center justify-center ${className}`}
        style={{ backgroundColor: color }}
        data-testid="product-image-placeholder"
      >
        <span className="text-[#9A9E97] text-2xl">🌱</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={`object-cover ${className}`}
      onError={(e) => {
        e.currentTarget.style.display = "none";
        e.currentTarget.parentElement.style.backgroundColor = color;
      }}
    />
  );
};
